<button class="btn btn-custom btn-optional" [ngStyle]="{
    '--bg-color': btnBgColor,
    '--text-color': btnTextColor,
    '--hover-bg-color': btnHoverBgColor,
    '--hover-text-color': btnHoverTextColor,
    '--padding': padding
}" [disabled]="disable" type="button" [attr.aria-label]="ariaLabel ?? label ?? null"
    [attr.title]="ariaLabel ?? null">
    <img [src]="icon" class="me-2 ms-2" style="width: 20px; height: 20px;" *ngIf="icon && !isLoading" />
    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    <ng-container *ngIf="label">
        {{label}}
    </ng-container>
</button>